import localforage from "localforage";
import { devError, devInfo } from "./logging";
import { toast } from "react-toastify";

const CACHE_EXPIRY = 4 * 60 * 60 * 1000;

export const clearAllCache = async () => {
  try {
    await localforage.clear();

    toast.success("Local Cache cleared successfully!");
  } catch (e) {
    devError("Error clearing local cache:", e);
    toast.error("Failed to clear local cache.");
  }
};

const invalidateCache = async (cacheKey) => {
  try {
    // Clear the cache for the specified table
    await localforage.removeItem(`cache_${cacheKey}`);
  } catch (error) {
    console.error("Error invalidating cache:", error);
  }
};

export const retrieveFromCache = async (cacheKey) => {
  try {
    const cachedData = await localforage.getItem(`cache_${cacheKey}`);
    if (!cachedData || !cachedData.timestamp || !cachedData.data) return null;
    if (Date.now() - cachedData.timestamp >= CACHE_EXPIRY) return null;
    return cachedData.data;
  } catch (error) {
    console.error("Error retrieving from cache:", error);
    return null;
  }
};

export const storeInCache = async (cacheKey, data) => {
  try {
    await localforage.setItem(`cache_${cacheKey}`, {
      timestamp: Date.now(),
      data,
    });
  } catch (error) {
    console.error("Error storing in cache:", error);
  }
};
